import type { ObjectManagerDirtyFields } from 'slices/object.slice';
import type { TTEObject } from '@timeedit/types/lib/types';
import { Associations } from './sections/Associations';
import Fields from './sections/Fields';
import GeneralInfo from './sections/GeneralInfo';

export interface ObjectManagerDetailProps {
  dirtyFields?: ObjectManagerDirtyFields;
  object: TTEObject;
  onChange: (object: Partial<TTEObject>) => void;
}

const ObjectManagerDetail = ({
  object,
  onChange,
  dirtyFields,
}: ObjectManagerDetailProps) => (
  <div>
    <GeneralInfo
      object={object}
      onChange={onChange}
      dirtyFields={dirtyFields}
    />
    <Fields object={object} onChange={onChange} dirtyFields={dirtyFields} />
    <Associations
      object={object}
      onChange={onChange}
      dirtyFields={dirtyFields}
    />
  </div>
);

export default ObjectManagerDetail;
